import Logger from 'js-logger'

Logger.useDefaults()
// Logger.setLevel(process.env.NODE_ENV === 'production' ? Logger.WARN : Logger.DEBUG)
Logger.setLevel(Logger.DEBUG)
export default Logger
